import { userId } from "../Contexts/LocaleContext";
import { ApiUtility } from "./ApiUtility";

class ProfileService {
  profileRoute = "/api/user/profile?medium=1&lang=";
  favRoute = "/api/user/favourites?lang=";
  profiledata = "/api/user/profile";
  country = "/api/Settings/Country?lang=";
  state = "/api/Settings/state?lang=";
  city = "/api/Settings/state/";
  profilepic = "/api/user/profilepicture?id="


  getProfilepicture = (id: string) => {
    return ApiUtility.get(
      this.profilepic + id + '&isThumb=1')
  }

  getfavData(start: number, length: number) {
    return ApiUtility.get(
      this.favRoute + localStorage.getItem("lan") + "&start=" + start + "&length=" + length
    );
  };

  /** Aggregate favourite counts for the profile Knowledge Journey section. */
  getFavouritesSummary = (lang: string) => {
    return ApiUtility.post(
      "/api/user/favourites/summary?lang=" + encodeURIComponent(lang || ""),
      {}
    );
  };

  getbookmarks(start: number, length: number) {
    return ApiUtility.get(
      this.favRoute + localStorage.getItem("lan") + "&start=" + start + "&length=" + length
    )
  }

  getProfile = (lang: string) => {
    return ApiUtility.get(this.profileRoute + lang);
  };

  UserProfile = (lan: any) => {
    return ApiUtility.get(
      this.profiledata + "&medium=1", "&lang=" + lan,
    );
  }

  getCountry = (lan: any) => {
    return ApiUtility.get(
      this.country + lan,
    )
  }

  /** GET /api/Settings/state?lang=  or  /api/Settings/state?Country={countryId}&lang= */
  getState = (lang: string, countryId?: string) => {
    const langQ = "lang=" + encodeURIComponent(lang || "");
    if (countryId) {
      return ApiUtility.get(
        "/api/Settings/state?Country=" + encodeURIComponent(countryId) + "&" + langQ
      );
    }
    return ApiUtility.get("/api/Settings/state?" + langQ);
  }

  /** GET /api/Settings/state/{id}?lang= — cities for the selected state. */
  getDistrict = (stateId: string, lang: string) => {
    return ApiUtility.get(
      this.city + stateId + "?lang=" + lang
    )
  }

  updateUserProfile = (
    name: string,
    email: string,
    baseFile: any,
    address1: any,
    address2: string,
    city: string,
    state: string,
    country: string,
    countrytype: string,
    pinCode: string,
    language: string,
    mobileNo: string,
    firstName?: string,
    lastName?: string,
    gender?: number | "",
    age?: number | "",
    countryCode?: string
  ) => {
    const body: Record<string, unknown> = {
      userId: userId,
      name: firstName || name,
      firstName: firstName || name,
      lastName: lastName ?? "",
      email: email,
      address: {
        address1: address1,
        address2: address2,
        city: city,
        state: state,
        country: country,
        countryType: countrytype,
        pinCode: pinCode,
      },
      language: language,
      medium: 1,
      phoneNumber: mobileNo,
    };

    // Omit imagePath when unchanged so the API keeps the stored photo
    if (baseFile) {
      body.imagePath = baseFile;
    }
    if (gender === 1 || gender === 2 || gender === 3) {
      body.gender = gender;
    }
    if (typeof age === "number" && age >= 1 && age <= 120) {
      body.age = age;
    }

    if (countryCode !== undefined) {
      body.countryCode = countryCode;
    }

    return ApiUtility.post(this.profiledata, body);
  }

  /** Send OTP for a new profile mobile (verifyType 3) or email (verifyType 4). */
  sendProfileOtp = (payload: {
    verifyType: 3 | 4;
    mobileNo?: string;
    email?: string;
    oldKey?: string;
  }) => {
    const body: Record<string, unknown> = {
      verifyType: payload.verifyType,
    };
    if (payload.mobileNo) {
      body.mobileNo = payload.mobileNo;
    }
    if (payload.email) {
      body.email = payload.email;
    }
    if (payload.oldKey) {
      body.oldKey = payload.oldKey;
      body.appCode = payload.oldKey;
    }
    return ApiUtility.post("/api/user/sendotp", body);
  }

  /** Partial profile save: requestType 2 mobile / 3 email after OTP. */
  updatePersonalInfo = (body: Record<string, unknown>) => {
    return ApiUtility.post("/api/user/profile/personal", body);
  }

  /** Photo only. imagePath is a data URI to upload, or "clear" to remove. */
  updateProfilePicture = (imagePath: string) => {
    return ApiUtility.post("/api/user/profilepicture", { imagePath });
  }

  /**
   * Account delete-request flow.
   * requestMode: 1 Request OTP, 2 Verify, 3 Cancel (re-activate), 4 GetStatus.
   */
  postUserRequest = (requestMode: 1 | 2 | 3 | 4) => {
    return ApiUtility.post("/api/user/userrequest", { requestMode });
  }

}
export default new ProfileService();

